import ReactDOM from "react-dom";
import { publicAssetUrl } from "../../config";

  
  const Modal = ({
    closeModal,
    modalRef,
    selectedTab,
    setSelectedTab,
  }) => {
    return ReactDOM.createPortal(
      <div ref={modalRef} className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg w-[100vh] h-[80vh]">
          <div className="flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t-lg">
            <h2 className="font-semibold">Page Structure</h2>
            <button className="text-black hover:text-gray-200 focus:outline-none" onClick={closeModal}>
              ×
            </button>
          </div>
          <div className="flex gap-x-2 p-2">
            <button
              className={`flex-1 text-center ${selectedTab === "headings" ? "bg-blue-100" : "bg-gray-200"} font-semibold rounded-xl focus:outline-none`}
              onClick={() => setSelectedTab("headings")}
            >
              Headings
            </button>
            <button
              className={`flex-1 text-center ${selectedTab === "landmarks" ? "bg-blue-100" : "bg-gray-200"} font-semibold rounded-xl focus:outline-none`}
              onClick={() => setSelectedTab("landmarks")}
            >
              Landmarks
            </button>
            <button
              className={`flex-1 text-center ${selectedTab === "links" ? "bg-blue-100" : "bg-gray-200"} font-semibold rounded-xl focus:outline-none`}
              onClick={() => setSelectedTab("links")}
            >
              Links
            </button>
          </div>
          <div className="p-4">
            <div className="space-y-4">
              {selectedTab === "headings" && (
                <>
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="flex items-center">
                      <div className="bg-blue-500 font-bold rounded-full h-5 w-5 flex items-center justify-center">
                        <img src={publicAssetUrl("H1.png")} alt="H1 Icon" className="h-2 w-2" />
                      </div>
                      <p className="ml-1 text-gray-800 text-xs">Next-gen</p>
                    </div>
                  ))}
                </>
              )}
              {selectedTab === "landmarks" && (
                <>
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="flex items-center">
                      <div className="bg-gray-500 font-bold rounded-full h-5 w-5 flex items-center justify-center">
                        <img src={publicAssetUrl("landmarks.png")} alt="Landmark Icon" className="rounded-full h-4 w-4" />
                      </div>
                      <p className="ml-1 text-gray-800 text-xs">Next-gen</p>
                    </div>
                  ))}
                </>
              )}
              {selectedTab === "links" && (
                <>
                  {[...Array(4)].map((_, i) => (
                    <div key={i} className="flex items-center">
                      <div className="bg-gray-500 font-bold rounded-full h-5 w-5 flex items-center justify-center">
                        <img src={publicAssetUrl("links.png")} alt="Link Icon" className="rounded-full h-3 w-3" />
                      </div>
                      <p className="ml-1 text-gray-800 text-xs">Next-gen</p>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  };


    export default Modal;